export default "__VITE_ASSET__uDC7cfP3__"